import template from './manage-my-rlink.html'
import './manage-my-rlink.styl'

let component = {
  restrict: 'E',
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/manage-my-rlink.component.js